import React, { Component } from 'react'
import { withRouter } from 'react-router'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import ProjectUpdatePageUI from './ProjectUpdatePageUI.js'

class ProjectUpdatePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      project: null,
      projectList: null,
      messageList: null,
      deleteMode: false
    }
  }

  render() {
    return (
      <ProjectUpdatePageUI
        context={this.props.context}
        project={this.state.project}
        projectList={this.state.projectList}
        messageList={this.state.messageList}
        deleteMode={this.state.deleteMode}
        onDeleteClick={() => {this.setState({deleteMode: true})}}
        onCancelDeleteClick={() => {this.setState({deleteMode: false})}}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProjects(context)
    this.getMessages(context)
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getProjects(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/projects`,
      cacheKey: CacheKeys.Projects(context.session.accountId, context.session.userId),
      callback: this.getProjectsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectsCallback = (response) => {
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }
    let projectsFiltered = response.projectList.filter(project => project.projectId === this.props.match.params.projectId)
    if (projectsFiltered.length === 1) {
      this.setState({projectList: response.projectList, project : projectsFiltered[0]})
    }
    else {
      let context = this.props.context
      CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId))
      this.props.history.replace('/projects')
    }
  }

  getMessages(context) {
    let arr = [
      'c_project_settings',
      'c_template_settings',
      'c_short_code',
      'c_project_name',
      'c_template_name',
      'c_status',
      'c_visibility',
      'c_sharable_name',
      'c_description',
      'c_announcement',
      'c_shortcode_taskid_tip',
      'c_prj_desc_tip',
      'c_prj_announce_tip',
      'c_update',
      // delete
      'c_delete_project',
      'c_delete_template',
      'c_delete',
      'c_cancel',
      'c_delete_project_conf',
      'c_delete_template_conf',
      //
      'c_project_users',
      'c_template_users'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_prj_upd', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(ProjectUpdatePageSF)
